module.exports = __webpack_public_path__ + "static/media/loadLogo.3b34e5e5.svg";